import { IAppState } from 'src/store/types';
import { ILocale } from 'src/typings/locale';

export const getLocale = (state: IAppState): ILocale | null => state.locale;
